import vueInstance from '../index'

var originJSONP = require('jsonp')

export function jsonpParam (data) {
  let demoUrl = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    demoUrl += '&' + k + '=' + encodeURIComponent(value)
  }
  return demoUrl ? demoUrl.substring(1) : ''
}

// 暴力深拷贝
export function copy (data) {
  return JSON.parse(JSON.stringify(data))
}

// 输入 Date 对象，返回 YYYY-MM-DD 格式字符串
export function formatDate (date) {
  const monthMapping = ['01','02','03','04','05','06','07','08','09','10','11','12']
  var mappedDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  return [date.getFullYear(), monthMapping[date.getMonth()], mappedDate].join('-')
}
// 输入 Date 对象，返回 YYYY-MM-DD HH:mm:ss 格式字符串
export function formatDateTime (date) {
  const monthMapping = ['01','02','03','04','05','06','07','08','09','10','11','12']
  var mappedDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  return [[date.getFullYear(), monthMapping[date.getMonth()], mappedDate].join('-'),date.toTimeString().substr(0,8)].join(' ')
}

//金额格式化  输入数字类型的金额  返回制定小数位及千分位分割的金额
export function formatMoney(s, n) {  
    n = n >= 0 && n <= 20 ? n : 2;  
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + ""; 

    var l = s.split(".")[0].split("").reverse()
    var r = n>0?s.split(".")[1]:""  
    var t = "";  
    for (var i = 0; i < l.length; i++) {  
        t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? "," : "");  
    }  
    return n>0?(t.split("").reverse().join("") + "." + r):(t.split("").reverse().join(""))
}  
export function isOnlineService(businessId) {
  let isOnline = false
  let onlineServices = [
    'online_tts', 'tts', 'online_asr', 'iat', 'ise', 'wse',
    'hw', 'recognize_document', 'general', 'business_card', 'idcard', 
    'bankcard', 'business_license', 'invoice', 'rta'
  ]
  onlineServices.map(serviceId => {
    if(serviceId == businessId){
      isOnline = true
    }
  })
  return isOnline
}
export function isNlzjj(businessId) {
  let isOnline = false
  let onlineServices = ['xfyeta']
  onlineServices.map(serviceId => {
    if(serviceId == businessId){
      isOnline = true
    }
  })
  return isOnline
}
export function serviceType(wareType) {
  switch (wareType) {
    case 1: {
      return '服务量'
      break
    }
    case 2: {
      return '装机量'
      break
    }
    case 3: {
      return ''
      break
    }
  }
}
// 封装jsonp
export function jsonpInfo(url, data, option) {
  url += (url.indexOf('?')<0?'?':'&') + jsonpParam(data) + '&timestamp=' + new Date().getTime()
  return new Promise(function(resolve,reject) {
    originJSONP(url,option, function(err,data) {
      if(!err){
        resolve(data)
      }else{
        reject(err)
      }
    })
  })
}

export function getCookie(name) {
	var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
	return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
}

//判断用户实名认证状态
/**
 * @certificatedCallback {function} 实名认证成功的回调
 * @noCertificatedCallback {function} 实名认证失败的回调
 */
export function checkCertificationStatus(certificatedCallback, noCertificatedCallback) {
  if (!vueInstance.$store.state.auth.isCertificated) {
    var tip = ''
    switch (vueInstance.$store.state.auth.certificateType) {
      case '4': 
        tip = '实名认证未通过，重新认证?'
        break
      case '5':
        tip = '实名认证审核通过后才能执行此操作，目前正在审核中，查看审核情况？'
        break
      default:
        tip = '尚未实名认证，现在认证?' 
    }
    vueInstance.$confirm(tip, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      if (noCertificatedCallback) {
        noCertificatedCallback()
      } else {
        vueInstance.$router.push({
          path: '/user/authentication',
          query: { backurl: '/app/myapp' }
        })
      }
    }).catch(() => {
    })
  } else {
    if (certificatedCallback) certificatedCallback()
  }
}



// WEBPACK FOOTER //
// ./app/libs/utils.js